







import { defineComponent } from '@vue/composition-api';

import MyApp from '@/base/app/components/MyApp.vue';

import ActivateAccount from '../components/organisms/ActivateAccount.vue';

export default defineComponent({
  name: 'AccountActivateAccountPage',
  components: { MyApp, ActivateAccount },
  props: { id: { type: String, required: true } },
});
